function Header() {
    return (
        <header>
            <h1>
                Leksehjelp bjerke 26/27
            </h1>
        </header>
    );
};

export default Header;